module.exports = __webpack_public_path__ + "img/undraw_relaxation_1_wbr7.f59605d6.svg";